// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"c4840d15","120":"a57a4377","856":"c771dff3"}[chunkId] + ".js";
};